// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar{object-fit:cover;border-radius:100px;box-shadow:0px 3px 6px #000029}", "",{"version":3,"sources":["webpack://./app/pages/components/avatar/index.scss"],"names":[],"mappings":"AAAA,QACE,gBAAA,CACA,mBAAA,CACA,8BAAA","sourcesContent":[".avatar {\n  object-fit: cover;\n  border-radius: 100px;\n  box-shadow: 0px 3px 6px #000029;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
